import type { TTipoDocumento } from '@/features/enviar-documentos/services'

export const listaDocumentosPessoaFisica: Array<{ value: TTipoDocumento; label: string }> = [
  { value: 'CNH', label: 'CNH' },
  { value: 'RG', label: 'RG' },
  { value: 'CPF', label: 'CPF' },
  { value: 'CertidaoDeNascimento', label: 'Certidão de Nascimento' },
  { value: 'CertidaoDeCasamento', label: 'Certidão de Casamento' },
  { value: 'ComprovanteDeResidencia', label: 'Comprovante de Residência' },
  { value: 'Procuracao', label: 'Procuração' },
  { value: 'OutroDocumento', label: 'Outro Documento' },
  { value: 'ComprovanteDePagamento', label: 'Comprovante de Pagamento' },
  { value: 'Checklist', label: 'Checklist' },
]
